import React, { Component } from 'react';
import { Form, Col } from "react-bootstrap";

import styles from './styles.module.css';

import Button from '../../../../components/Buttons/Button';
import Modal from '../../../../components/Modal';
import ModalConfirm from '../../../../components/ModalConfirm';
import Header from '../../../../components/Header';

import api from '../../../../services/api';
import { API_GUARD } from '../../../../services/env';

export default class Branches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      branches: [],
      companies: [],
      pabx_id: props.location.state.params,
      companyId: "",
      isAlertOn: false,
      isExclusionConfirmOn: false,
      marked_branch_id: null,
      modalConfirm: {
        title: "",
        text: ""
      },
      alertMessage: {
        title: "",
        message: ""
      }
    }
    this.getBranches = this.getBranches.bind(this);
    this.toggleIsLoad = this.toggleIsLoad.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggleConfirm = this.toggleConfirm.bind(this);
    this.handlerConfirm = this.handlerConfirm.bind(this);
  }

  async handlerChangeInput(value) {
    const key = Object.keys(value)[0];
    await this.setState({
      ...value,
      validate: {
        ...this.state.validate,
        [key]: {
          message: "",
          isInvalid: false
        }
      }
    });
    this.getBranches();
  }

  componentDidMount() {
    this.getBranches();
  }

  toggleAlert() {
    this.setState({
      isAlertOn: !this.state.isAlertOn,
    });
  }

  toggleConfirm(branch) {
    if (branch) {
      const { id, number } = branch;
      this.setState({
        marked_branch_id: id,
        isExclusionConfirmOn: !this.state.isExclusionConfirmOn,
        modalConfirm: {
          title: "Excluir Ramal",
          message: `Tem certeza que deseja excluir o ramal nº ${number}?`
        }
      });
    } else {
      this.setState({
        marked_branch_id: null,
        isExclusionConfirmOn: false,
        modalConfirm: {
          title: "",
          message: ""
        }
      });
    }
  }

  activeAlert(alertMessage) {
    const { title, message } = alertMessage;
    this.setState({
      ...this.state,
      isAlertOn: true,
      alertMessage: {
        title,
        message
      }
    });
  }

  toggleIsLoad(boolean) {
    this.setState({ isLoading: boolean });
  }

  async getBranches() {
    try {
      this.toggleIsLoad(true);
      const { companyId } = this.state;
      const access_token = await localStorage.getItem("access_token");
      const url = companyId ? `/v1/${API_GUARD}/pabx/${this.state.pabx_id}/branches/${companyId}` : `/v1/${API_GUARD}/pabx/${this.state.pabx_id}/branches`;
      const response = await api.get(url, {
        headers: { Authorization: "Bearer " + access_token }
      });
      if (response.status && response.status === 200) {
        const { branches, company } = response.data;
        companyId ? this.setState({ branches }) : this.setState({ branches, company });
      }
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            const { message } = error.response.data;
            this.setState({
              message
            });
            break;
          case 422:
            const { errors } = error.response.data;
            for (let key in errors) {
              this.setState({
                validate: {
                  ...this.state.validate,
                  [key]: {
                    message: errors[key],
                    isInvalid: true
                  }
                }
              });
            }
            break;
          default:
            this.error();
        }
      }
    }
    this.toggleIsLoad(false);
  }

  error() {
    const alert = {
      title: "Ops... Algo deu errado.",
      message: "Não foi possível completar sua requisição."
    }
    this.activeAlert(alert);
  }

  handlerHeaderCreateBranch() {
    const { history } = this.props;

    history.push(`/admin/PABX/ramais/adicionar`, {params: this.state.pabx_id});
  }

  handlerHeaderEditBranch(id) {
    const { history } = this.props;

    history.push(`/admin/PABX/ramais/${id}/editar`, {params: this.state.pabx_id});
  }

  handlerConfirm() {
    const id = this.state.marked_branch_id;
    this.handlerDestroyBranch(id);
  }

  async handlerDestroyBranch(id) {

    if (!this.state.isLoading) {
      this.toggleIsLoad(true);
      try {
        const access_token = await localStorage.getItem("access_token");
        const response = await api.delete(`/v1/${API_GUARD}/pabx/${this.state.pabx_id}/branch/${id}`, {
          headers: { Authorization: "Bearer " + access_token }
        });
        if (response.status && response.status === 200) {
          const { title, message } = response.data;
          this.activeAlert({ title, message });
        }
        this.getBranches()
      } catch (error) {
        if (error.response) {
          switch (error.response.status) {
            case 422:
              const { errors } = error.response.data;
              for (let key in errors) {
                this.setState({
                  validate: {
                    ...this.state.validate,
                    [key]: {
                      message: errors[key],
                      isInvalid: true
                    }
                  }
                });
              }
              break;
            default:
              this.error();
          }
        }
        this.toggleIsLoad(false);
      }
    }
  }

  render() {
    const { isLoading, branches, companies } = this.state;
    return (
      <div className={`${styles.container}`}>
        <Header title="Ramais" description="Gerenciamento de Ramais" />
        <div className={`${styles.body} ${styles.shadowBox}`}>
          <div className={styles.tableHeader}>
            <div className={styles.tableTitle}>
              <h2>Listagem de Ramais</h2>
            </div>
            <br />
            <div className={styles.tableOption}>
              <Col xs="8" md="5">
                <Form.Control as="select"
                  onChange={event => {
                    // console.log(event.target.value);
                    this.handlerChangeInput({ companyId: event.target.value })
                  }}
                >
                  <option value={""}>Todos</option>
                  {companies.map((company, index) => (
                    <option key={index} value={company.id}>{company.name}</option>
                  )
                  )}
                </Form.Control>
              </Col>
              <Button text='Voltar' arrowLeft={true} onClick={this.props.history.goBack}/>
              <Button text="Adicionar"
                type="button"
                onClick={() => { this.handlerHeaderCreateBranch() }}
              />
            </div>
          </div>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>#</th>
                <th>Número</th>
                <th>Responsável</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {
                isLoading ? (
                  <tr>
                    <th colSpan="5">Carregando listagem...</th>
                  </tr>
                ) :
                  !(branches.length > 0) ? (
                    <tr>
                      <th colSpan="5">Nenhum registro encontrado.</th>
                    </tr>
                  ) :
                    branches.map((branch, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{branch.number}</td>
                        <td>{branch.branch_users ? branch.branch_users.name : "Sem Responsável"}</td>
                        <td>
                          <div className={styles.tableButton}>
                            <Button text="Editar"
                              type="button"
                              onClick={() => { this.handlerHeaderEditBranch(branch.id) }}
                            />
                            <div className={styles.margin} />
                            <Button text="Excluir"
                              type="button"
                              onClick={() => { this.toggleConfirm(branch) }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))
              }
            </tbody>
          </table>
          <Modal
            isActive={this.state.isAlertOn}
            toggleAlert={this.toggleAlert}
            title={this.state.alertMessage.title}
            text={this.state.alertMessage.message}
          />
          <ModalConfirm
            isActive={this.state.isExclusionConfirmOn}
            toggleConfirm={this.toggleConfirm}
            handlerConfirm={() => { this.handlerConfirm(); this.toggleConfirm(null) }}
            title={this.state.modalConfirm.title}
            text={this.state.modalConfirm.message}
          />
        </div>
      </div>
    );
  }
}
